import { render, staticRenderFns } from "./LightSideBar.vue?vue&type=template&id=4f378584"
import script from "./LightSideBar.vue?vue&type=script&lang=js"
export * from "./LightSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports